import { render } from "./CurrencyJsonTD.vue?vue&type=template&id=2c14b4a6"
import script from "./CurrencyJsonTD.vue?vue&type=script&lang=js"
export * from "./CurrencyJsonTD.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__